import { html, LitElement } from 'lit-element';
import { processEscapedMarkup } from '../../utils.js';

/**
 * @element question-modal-ecr
 * @prop {Object} model - Response
 */
export class QuestionModalECR extends LitElement {
  static get properties() {
    return {
      model: {
        type: Object,
        attribute: false,
      },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { markup } = this.model || {};

    if (!markup) return '';

    const text = processEscapedMarkup(markup);

    const textValue = text.replace(/\{\{(.)\}\}/g, () => {
      return `
        <span class='question-modal-answer-ecr'></span>`;
    });

    return html`<div>
      <div class="question-modal modal-response-content">
        <math-rendering-element .label=${textValue}></math-rendering-element>
      </div>
    </div>`;
  }
}

export default QuestionModalECR;
